const loader = (() => {
  

  var loaderIsHere = document.getElementsByClassName('page-loading');
  if (loaderIsHere.length > 0) {

    (function () {
      window.onload = function () {
        var preloader = document.querySelector('.page-loading');
        preloader.classList.remove('active');
        setTimeout(function () {
          preloader.remove();
        }, 2000);
      };
    })();
  }

})();
  
export default loader;